import { render, staticRenderFns } from "./registroPagosDetail.vue?vue&type=template&id=7a7cefc3&scoped=true"
import script from "./registroPagosDetail.vue?vue&type=script&lang=js"
export * from "./registroPagosDetail.vue?vue&type=script&lang=js"
import style0 from "./registroPagosDetail.vue?vue&type=style&index=0&id=7a7cefc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7cefc3",
  null
  
)

export default component.exports